import {ProductionController} from "@/controllers/production/ProductionController";
import {idOf} from "@/purchase/utils";

// Dossiers (ms-production) proposés pour y ventiler des achats ou y affecter du stock.
// Renvoie undefined sans l'option production (ou si les dossiers ne peuvent pas être lus) : les écrans masquent alors les dossiers.
export async function loadOrderValues() {
    if (!(localStorage.options && localStorage.options.includes("production"))) return undefined;

    const orders = await ProductionController.getAll("");
    if (!orders || orders.errors) return undefined;
    return orders
        .sort((a, b) => Number(b.number) - Number(a.number))
        .map(order => ({label: `N°${order.number} - ${order.title}`, value: idOf(order)}));
}
